import { ApiError } from "@vana/core";

export class ListReferralsError extends ApiError {}
export class CreateReferralError extends ApiError {}
export class GetOriginationUrlError extends ApiError {}
export class GetReferralCodeError extends ApiError {}
